import React, { useState, useEffect, useRef } from "react";
import Grow from "@mui/material/Grow";
import Paper from "@mui/material/Paper";
import Popper from "@mui/material/Popper";
import makeStyles from "@mui/styles/makeStyles";

import SingleSelecteListNoSearch from "./SingleSelecteListNoSearch";

import blueDownArrow from "../images/blueDownArrow.svg";
import grayDownArrow from "../images/grayDownArrow.svg";
import blueUpArrow from "../images/blueUpArrow.svg";
import "../styles/components/TemplateTypeDropDown.scss";
import { ClickAwayListener } from "@mui/material";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "inline-block",
  },
  paper: {
    marginRight: theme.spacing(2),
  },
}));

const TemplateTypeDropDown = ({
  title,
  data,
  disabled = false,
  selectedFilterData,
  handleChange,
  borderNotDisabled,
}) => {
  const [isOpen, toggleisOpen] = useState(false);
  const [selectedData, setSelectedData] = useState(undefined);
  const classes = useStyles();
  const anchorRef = useRef(null);
  const [initialLoad, toggleInitialLoad] = useState(true);
  const [filteredList, setFilteredList] = useState([]);
  const [searchText, setSearchText] = useState("");

  const handleToggle = () => {
    toggleisOpen((prevOpen) => !prevOpen);
  };

  useEffect(() => {
    setSelectedData(selectedFilterData);
  }, [selectedFilterData]);

  const handleClose = (event) => {
    toggleisOpen(false);
  };

  // return focus to the button when we transitioned from !open -> open
  const prevOpen = React.useRef(isOpen);
  useEffect(() => {
    if (prevOpen.current === true && isOpen === false) {
      setSelectedData(selectedFilterData);
      setSearchText("");
      anchorRef.current.focus();
    }

    prevOpen.current = isOpen;
    enableDisableApplyButton();
  }, [isOpen]);
  const enableDisableApplyButton = () => {
    if (!isOpen) {
      toggleInitialLoad(true);
      return;
    }
    toggleInitialLoad(isOpen && (selectedFilterData || [])?.length === 0);
  };

  const getArrow = () => {
    if (isOpen) {
      return blueUpArrow;
    } else if (disabled) {
      return grayDownArrow;
    }
    return blueDownArrow;
  };
  useEffect(() => {
    setFilteredList(data);
  }, [data]);
  useEffect(() => {
    searchResults(searchText);
  }, [searchText]);
  const searchResults = (searchText) => {
    if (!data) {
      return;
    }
    let filterData = [...data];

    // Filter by Search Input
    if (searchText && searchText?.trim()) {
      searchText = searchText?.toLowerCase();
      filterData = filterData.filter((item) => {
        const textToMatch =
          typeof item === "string"
            ? item
            : item?.displayName || item?.label || item?.value || "";
        return textToMatch.toLowerCase().includes(searchText);
      });
    }
    setFilteredList(filterData);
  };
  return (
    <div className={`filterContainer ${classes.root}`}>
      <div
        className={`btn multiselect-dropdown ${isOpen || borderNotDisabled ? "active" : ""} ${
          disabled ? "disabled" : ""
        }`}
        ref={anchorRef}
        aria-controls={isOpen ? "menu-list-grow" : undefined}
        aria-haspopup="true"
        disabled={disabled}
        onClick={() => {
          if (disabled) {
            return;
          }
          handleToggle();
        }}
      >
        {" "}
        {title}
        <img src={getArrow()} alt="" style={{ marginLeft: "4px" }} />
      </div>
      <Popper
        open={isOpen}
        anchorEl={anchorRef.current}
        role={undefined}
        transition
        className="multi-select-dropdown-outer single-select-dropdown-no-search"
        placement="bottom-end"
      >
        {/*  */}
        {({ TransitionProps }) => (
          <Grow {...TransitionProps}>
            <Paper className="paper-comp">
              <ClickAwayListener onClickAway={handleClose}>
                <div>
                  <SingleSelecteListNoSearch
                    data={filteredList}
                    anchorRef={anchorRef}
                    open={isOpen}
                    selected={selectedData}
                    height="200px"
                    handleClose={handleClose}
                    handleChange={handleChange}
                  />
                </div>
              </ClickAwayListener>
            </Paper>
          </Grow>
        )}
      </Popper>
    </div>
  );
};

export default TemplateTypeDropDown;
